angular.module('elogbooksDirectives').directive('checkboxMultiSelect', ['lodash', '$document', '$timeout', function (lodash, $document, $timeout) {
    return {
        scope: {
            options: '=',
            selected: '=',
            placeholder: '@',
            disabled:'@?',
            field: '@?',
            orderBy: '@?',
            preselect: '@?',
            searchableKeys: '=' // Array of keys to search eg: ['name', 'id']
        },
        templateUrl: '/modules/directives/form-elements/checkbox-multi-select/checkbox-multi-select.html',
        link: function(scope, element, attrs) {
            // Generate a unique random ID for this instance
            scope.inputId = 'checkbox-input-' + Math.random().toString(36).substring(2, 15);

            if(!scope.preselect) {
                angular.forEach(scope.options, function(value) {
                    if (value.checked) {
                        value.checked = false;
                    }
                });
            } else {
                angular.forEach(scope.options, function(option, key) {
                    if (lodash.find(scope.selected, {
                            name: option.name
                        })) {
                        scope.options[key].checked = true;
                    }
                });
            }

            //Events required on change
            scope.raiseEvents = lodash.has(attrs, 'raiseEvents');

            scope.visible = false;

            if (scope.field) {
                angular.forEach(scope.options, function (value, index) {
                    value.name = value[scope.field];
                });
            }

            scope.selectClick = function (option) {
                var selected = {
                    label: option.label || option.name,
                    name: option.name
                };

                if (option.id) {
                    selected.id = option.id;
                }

                if (option.object) {
                    selected.object = option.object;
                }

                if (option.checked) {
                    scope.selected.push(selected);
                } else {
                    scope.selected = lodash.reject(scope.selected, selected);
                }

                if (scope.raiseEvents) {
                    scope.$emit('checkbox-multi-select:select:click', scope.selected);
                }
            }

            $document.on('click', function () {
                if (element.attr('visible') == 'visible') {
                    scope.$apply(
                        function () {
                            scope.visible = false;
                        }
                    );
                    element.attr('visible','');
                }
            });

            scope.hide = function () {
                scope.visible = false;
                element.attr('visible','');
            }

            scope.show = function () {
                scope.visible = true;
                $timeout(function () {
                    element.attr('visible','visible');
                }, 100);

            }

            scope.inputClick = function (event) {
                scope.toggle(event);
                $timeout(function () {
                    document.getElementById(scope.inputId).focus();
                });
            }

            scope.toggle = function (event) {
                if (scope.visible == true) {
                    scope.hide(event);
                } else {
                    scope.show(event);
                }
            }

            scope.dropDownClick = function (event) {
                event.stopPropagation();
            }

            scope.filterBySearchableKeys = function(query) {
                return function(element) {
                    if (!query) return true;

                    if (!scope.searchableKeys) {
                        return JSON.stringify(element).toLowerCase().indexOf(query.toLowerCase()) > -1;
                    } else {
                        var keys = scope.searchableKeys;
                        if (typeof keys === 'string') {
                            keys = keys.split(',').map(function(key) { return key.trim(); });
                        }

                        return lodash.some(keys, function(key) {
                            return element[key] &&
                                element[key].toString().toLowerCase().indexOf(query.toLowerCase()) > -1;
                        });
                    }
                };
            };
        }
    }
}]);
